import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/figtree/800.css";
import "@/shared/styles/globals.css";
import { registerVitePreloadRecovery } from "@/shared/utils/vitePreloadRecovery";
import { App } from "./App";

registerVitePreloadRecovery();

const container = document.getElementById("root");

if (!container) {
  throw new Error("Elemento root nao encontrado");
}

const serverData = window.__AUTOU_SERVER_DATA__ ?? null;
document.documentElement.classList.add("js-ready");
const hasSsrFallback = container.innerHTML.includes("AUTOU_SSR_FALLBACK");

const app = (
  <StrictMode>
    <App serverData={serverData} />
  </StrictMode>
);

if (container.hasChildNodes() && !hasSsrFallback) {
  hydrateRoot(container, app);
} else {
  if (hasSsrFallback) {
    container.innerHTML = "";
  }
  createRoot(container).render(app);
}
